import { MenuItem } from './MenuItem';

export class Menu {
    public triggerId: string;
    public menuItems: Array<MenuItem>;
    public parentMenuId?: string;

    constructor(triggerId: string, menuItems: Array<MenuItem>) {
        this.triggerId = triggerId;
        this.menuItems = menuItems;
    }
}
